import * as React from "react";

const FrontPage: React.FunctionComponent = () => {
    return (
        <div className="content">
            <p style={{margin: '10px auto'}}>
                Use the links above to access a number of simple utilities that are helpful for software development as
                well as just existing on the internet.
            </p>
            <p style={{margin: '10px auto'}}>
                Note: This website is a work-in-progress. In particular, CSS styling is a planned future element.
            </p>
        </div>
    );
};

export default FrontPage;